/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNestedValue = (p: any[], o: Record<string, unknown>): unknown =>
  p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o)
